import { array, dateTime, defineAction, enumerated, number, object, string } from '~/prix'
import entrepreneurAgentRequestAction from './entrepreneurAgentRequest.action.json'

const entrepreneurAgentRequestDefinition = defineAction({
  ...entrepreneurAgentRequestAction,
  input: object({
    entrepreneurCpf: string(),
    legalEntityCnpj: string().isOptional(),
    latitude: number(),
    longitude: number(),
    accuracy: number().isOptional(),
  }),
  output: object({
    pendingCount: number(),
    refusedCount: number(),
    agentsPreview: array(
      object({
        cpf: string(),
        latitude: number(),
        longitude: number(),
        accuracy: number(),
        lastGeolocationUpdate: dateTime(),
        geodesicDistanceMeters: number(),
        drivingDistanceMeters: number(),
        status: enumerated({
          waitingAnswer: 'waiting_answer',
          refused: 'refused',
          accepted: 'accepted',
        }),
      }),
    ),
  }),
})

export default entrepreneurAgentRequestDefinition
